<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="oeestate_keyno" [ttModel]="edit.oeestate_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="oeestate_name" [(ttModel)]="edit.oeestate_name"></tt-input>
        <tt-select ttLabel="color" [(ttModel)]="edit.color_id" [ttData]="selectListColours" ttDataId="color_id" ttDataName="color_name"></tt-select>
        <tt-checkbox ttLabel="showremark" [(ttModel)]="edit.showremark"></tt-checkbox>
        <tt-checkbox ttLabel="showprodid" [(ttModel)]="edit.showprodid"></tt-checkbox>
        <tt-checkbox ttLabel="showfields" [(ttModel)]="edit.showfields"></tt-checkbox>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        <tt-button-goto [ttText]="'oeestate_on_equipment'" [ttGoto]="'oeestate_equipments'" [ttGotoParms]="{ argtype: 'oeestate_keyno', argvalue: edit.oeestate_keyno }"></tt-button-goto>
        <tt-button-goto [ttText]="'oeestateremarks'" [ttGoto]="'oeestateremarks'" [ttGotoParms]="{ oeestate_keyno: edit.oeestate_keyno }"></tt-button-goto>
    </tt-card>
</tt-page>
